if (!customElements.get('nikuya-faq')) {
  customElements.define('nikuya-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.addEventListener('toggle', event => {
        const opened = event.target;
        if (!opened.matches('details[open]') || opened.closest('nikuya-faq') !== this) return;
        this.querySelectorAll('details[open]').forEach(row => {
          if (row !== opened) row.open = false;
        });
      }, {...options, capture: true});
      this.addEventListener('shopify:block:select', event => {
        const row = event.target.closest('details');
        if (row && this.contains(row)) row.open = true;
      }, options);
      this.resolveIntendedUse();
      document.addEventListener('DOMContentLoaded', () => this.resolveIntendedUse(), {...options, once: true});
      this.observer?.disconnect();
      this.observer = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node =>
          node.nodeType === 1 && (node.matches('template[data-intended-use]') || node.querySelector('template[data-intended-use]'))
        ))) this.resolveIntendedUse();
      });
      this.observer.observe(this, {childList: true, subtree: true});
      document.addEventListener('shopify:section:load', () => this.resolveIntendedUse(), options);
      document.addEventListener('shopify:section:unload', event => {
        this.querySelectorAll('[data-resolved-intended-use]').forEach(link => {
          const target = document.getElementById(link.hash.slice(1));
          if (!target || event.target.contains(target)) link.remove();
        });
      }, options);
    }
    resolveIntendedUse() {
      this.querySelectorAll('[data-resolved-intended-use]').forEach(link => link.remove());
      const targets = document.querySelectorAll('.nikuya-pdp-03[id^="NikuyaBestFor-"]');
      if (targets.length !== 1) return;
      this.querySelectorAll('template[data-intended-use]').forEach(template => {
        const link = template.content.querySelector('a').cloneNode(true);
        link.href = '#' + targets[0].id;
        link.dataset.resolvedIntendedUse = '';
        template.after(link);
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
